import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Typography } from 'ck-ui';
import { getPriceString } from 'ck-utils/price';
import layout from 'ck-utils/layout.module.scss';
import { BundleLookPageContext } from '../context';
import styles from './BundleLookPrice.module.scss';

const BundleLookPrice = ({ isModal }) => {
  const { bundle, comparedPrice } = useContext(BundleLookPageContext);

  if (bundle && !bundle.price) return null;

  const align = isModal ? 'centered' : 'right';
  return (
    <div className={classnames('is-flex', { [styles.flexColumn]: !isModal, [layout.marginRightLarge]: !bundle })}>
      <div className={classnames('is-flex-centered', { [styles.flexColumn]: !bundle || isModal, [styles.rightAlign]: !bundle && !isModal })}>
        <Typography color="black-bis" align={align} className={styles.label}>{bundle ? 'Bundle' : 'Look'} price</Typography>
        <Typography variant="heading5" display="inline" className={bundle ? styles.price : null}>
          {getPriceString(bundle ? bundle.price : comparedPrice, false, true)}
        </Typography>
      </div>
      {bundle && Number(bundle.compareAtPrice) > Number(bundle.price) && (
        <div className={classnames('is-flex-centered', { [styles.flexColumn]: isModal, [layout.marginTopSmall]: !isModal })}>
          <Typography color="black-bis" align={align} className={styles.label}>Was</Typography>
          <Typography variant="heading5" display="inline" strikeThrough color="danger" className={styles.price}>
            {getPriceString(bundle.compareAtPrice)}
          </Typography>
        </div>
      )}
    </div>
  );
};

BundleLookPrice.propTypes = {
  isModal: PropTypes.bool
};

BundleLookPrice.defaultProps = {
  isModal: false,
};

export { BundleLookPrice };
